import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { PrivateOnlyRouteController } from '../../smartLinks/authRouteControllers/PrivateOnlyRouteController';
import { OutreachHomeView } from './home/OutreachHomeView';
import { SoundProfileView } from './profile/SoundProfileView';
import { FindView } from './find/FindView';
import { CommunitiesView } from './communities/CommunitiesView';
import { ContactsView } from './contacts/ContactsView';
import { CampaignBuilderView } from './campaigns/CampaignBuilderView';
import { AllSongsResultsView } from './results/AllSongsResultsView';
import { CampaignLiveView } from './live/CampaignLiveView';
import { ReviewQueueView } from './review/ReviewQueueView';
import { InboxView } from './inbox/InboxView';

/**
 * The Outreach routes under `/app/outreach` (spec 2026-10-11 §6, plan Task 9). Every page needs a
 * signed-in person. The paths match `smlRoutePath` and `outreachPaths.ts`. Outreach is open to
 * every workspace (owner decision 2026-10-27); the plan decides what a page offers.
 */
export const OutreachRoutes: React.FC = () => (
  <PrivateOnlyRouteController>
    <Routes>
      <Route index element={<OutreachHomeView />} />
      <Route path="profile" element={<SoundProfileView />} />
      <Route path="find" element={<FindView />} />
      <Route path="communities" element={<CommunitiesView />} />
      <Route path="contacts" element={<ContactsView />} />
      <Route path="campaigns/new" element={<CampaignBuilderView />} />
      <Route path="campaigns/:campaignUuid" element={<CampaignLiveView />} />
      <Route path="campaigns/:campaignUuid/review" element={<ReviewQueueView />} />
      <Route path="results" element={<AllSongsResultsView />} />
      <Route path="inbox" element={<InboxView />} />
      <Route path="inbox/:replyUuid" element={<InboxView />} />
      <Route path="*" element={<OutreachHomeView />} />
    </Routes>
  </PrivateOnlyRouteController>
);
